import React, {memo} from 'react';

type PaddingRightProps = {
  amount: number;
};

export const PaddingRight = memo(({amount}: PaddingRightProps) => {
  return <div style={{paddingRight: amount}} />;
});
